import { atom } from 'recoil';
const getPostponeDueDateState = atom({
  key: 'getPostponeDueDateState',
  default: 0
});
export default getPostponeDueDateState;